import React from "react";
import { connect } from "react-redux";

import { bindActionCreators, Dispatch } from "redux";

import { SelectionMode, DataTableDef } from "@plex/react-components";

import { useLocalizedValues } from "ui/hooks";
import { ITerm } from "ui/screens/plex-dictionary";
import { displayMessages } from "ui/screens/translation-managers";

import { dictionaryLinksActions } from "../DictionaryLinks.actions";
import { IDictionaryLinksState } from "../DictionaryLinks.state";

export interface IDictionaryLinksGridProps {
  associatedTerms: ITerm[];
  selectAssociatedTerm: (termId: ITerm[]) => void;
  selectedTerm: ITerm[];
}

const DictionaryLinksGrid: React.FC<IDictionaryLinksGridProps> = ({ associatedTerms, selectAssociatedTerm, selectedTerm }) => {
  const localizedValues = useLocalizedValues(() => ({
    termTitle: displayMessages.property("term"),
    descriptionTitle: displayMessages.property("description")
  }));

  return (
    <DataTableDef<ITerm>
      selected={selectedTerm}
      keySelector={row => row.termId}
      selectionMode={SelectionMode.single}
      data={associatedTerms}
      onSelectionChanged={selectAssociatedTerm}
    >
      <DataTableDef.Column<ITerm> id="term" key="1" sortable shortTitle={localizedValues.termTitle} valueSelector={row => row.term}>
        {row => row.term}
      </DataTableDef.Column>
      <DataTableDef.Column<ITerm> id="description" key="2" sortable shortTitle={localizedValues.descriptionTitle} valueSelector={row => row.definition}>
        {row => row.definition}
      </DataTableDef.Column>
    </DataTableDef>
  );
};

export default connect(
  (state: { dictionaryLinks: IDictionaryLinksState }) => {
    return {
      associatedTerms: state.dictionaryLinks.associatedTerms,
      selectedTerm: state.dictionaryLinks.toDeleteAssociatedTerm
    };
  },
  (dispatch: Dispatch) =>
    bindActionCreators(
      {
        selectAssociatedTerm: dictionaryLinksActions.selectAssociatedTerm
      },
      dispatch
    )
)(DictionaryLinksGrid);
